module.exports = __webpack_public_path__ + "static/img/868_phase_function_Paper_PointsHejduk_Prediction.4c647c0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/868_phase_function_Paper_PointsHejduk_Prediction.png
// module id = hHPg
// module chunks = 0